import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '@shared/endpoints';

@Injectable({ providedIn: 'root' })
export class ScoringSystemService {
    constructor(private http: HttpClient) {}

    fetchScoringSystems() {
        return this.http.get<any[]>(
            endpoints.admin.children.getScoringProjects()
        );
    }

    updateScoringSystem(body: any) {
        return this.http.post<any>(
            endpoints.admin.children.getScoringProjects(),
            body
        );
    }

    fetchScoringSettingsGamePlatforms(gameId: string) {
        return this.http.get<any[]>(
            endpoints.admin.children.getScoringSettingsGamePlatforms() +
                '?Filters=GameId==' +
                gameId
        );
    }

    updateScoringSettingsGamePlatforms(gameId: string, body: any) {
        return this.http.post<any>(
            endpoints.admin.children.upsertScoringSettingsGamePlatforms(gameId),
            body
        );
    }
}
